import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@dch/ng-common/src/lib/shared';

const PROXIMUS_PLUS_WEBVIEW_USER_AGENT_IDENTIFIER = 'MyPxPlusApp';
class EnvironmentService {
    constructor(windowRef) {
        this.windowRef = windowRef;
        this.location = windowRef.nativeWindow.location;
    }
    get isLocal() {
        return this.location.hostname === 'localhost' && this.location.port === '4200';
    }
    get isItt() {
        return (this.location.host === 'www-itt.proximus.be' ||
            this.location.host === 'www-itt.scarlet.be' ||
            this.location.host === 'admit-itt.belgacom.be');
    }
    get isUat() {
        return (this.location.host === 'www-uat.proximus.be' ||
            this.location.host === 'www-uat.scarlet.be' ||
            this.location.host === 'admit-uat.belgacom.be');
    }
    get isProd() {
        return (this.location.host === 'www.proximus.be' ||
            this.location.host === 'www.scarlet.be' ||
            this.location.host === 'admit.belgacom.be');
    }
    get isDR() {
        return (this.location.host === 'dr.proximus.be' ||
            this.location.host === 'dr.scarlet.be' ||
            this.location.host === 'dr.belgacom.be');
    }
    get isIntraweb() {
        return /^.*intra.*.web.bc$/.test(this.location.host);
    }
    get isSphinx() {
        return this.location.host.indexOf('sphinx') > -1;
    }
    get isMobile() {
        return inception.breakpoints.isSmallOnly();
    }
    get isMedium() {
        return inception.breakpoints.isMediumOnly();
    }
    get isDesktop() {
        return inception.breakpoints.isLarge();
    }
    get isSmoothAccess() {
        return this.location.pathname.indexOf('/smoothAccess') === 0;
    }
    get isMagnolia() {
        return this.location.pathname.includes('.magnolia');
    }
    get isMyproximusMobileApp() {
        return this.windowRef.nativeWindow.MyProximusMobileApp === true;
    }
    get isMillennialsMobileApp() {
        return this.windowRef.nativeWindow.MillennialsMobileApp === true;
    }
    get isProximusPlusMobileApp() {
        return this.windowRef.nativeWindow.navigator.userAgent.includes(PROXIMUS_PLUS_WEBVIEW_USER_AGENT_IDENTIFIER);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: EnvironmentService, deps: [{ token: i1.WindowRef }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: EnvironmentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: EnvironmentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.WindowRef }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EnvironmentService, PROXIMUS_PLUS_WEBVIEW_USER_AGENT_IDENTIFIER };
